import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Button, VStack, Center } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers';
import { LoginProps, useLogin } from '@olo-web/domain/customer';
import { HookFormInput } from '@olo-web/components/molecules/HookFormInput/HookFormInput.ui';
import { Banner } from '@olo-web/components/atoms/Banner';
import { validationSchema } from './utils/validationSchema';

export function LoginForm({ onSuccess }: { onSuccess?: (data: any) => void }): JSX.Element {
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const { isLoading, error, mutate, reset } = useLogin({ onSuccess });

  return (
    <form
      role="Login form"
      aria-label="Login form"
      style={{ width: '100%' }}
      onSubmit={handleSubmit(mutate as SubmitHandler<LoginProps>)}
      noValidate
    >
      <VStack w="100%" spacing={6}>
        <HookFormInput
          isRequired
          isUsingYup
          label="Email"
          type="email"
          autoComplete="email"
          errors={errors}
          name="email"
          nameReq="email required"
          placeholder="yummy@food.com"
          ref={register}
          data-testid="login-email-input"
        />
        <HookFormInput
          isRequired
          isUsingYup
          label="Password"
          type="password"
          autoComplete="current-password"
          errors={errors}
          name="password"
          nameReq="password required"
          placeholder="•••••••••"
          ref={register}
          data-testid="login-password-input"
        />
      </VStack>
      <Center mt={10} flexDir="column">
        {error && (
          <Banner status="error" error={error} title="Unable to login" onClose={reset} mb={2} />
        )}
        <Button
          size="lg"
          colorScheme="primary"
          _focus={{
            boxShadow: 'none',
          }}
          _focusVisible={{
            boxShadow: 'none',
            outline: '3px solid #000',
            outlineOffset: '3px',
          }}
          loadingText="Signing in..."
          isLoading={isLoading}
          type="submit"
          data-testid="login-submit-button"
          width="100%"
        >
          Sign in
        </Button>
      </Center>
    </form>
  );
}
